import React from 'react';
import { CheckCircleTwoTone } from '@ant-design/icons';

const AuthHeader = ({ pillText, title, subtitle }) => (
  <div className="auth-header" style={{ textAlign: 'center', marginBottom: 8 }}>
    {pillText ? (
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 12px',
          borderRadius: 999,
          background: 'linear-gradient(135deg, rgba(0,77,84,0.08), rgba(0,77,84,0.06))',
          color: '#004d54',
          fontWeight: 600,
          fontSize: 12,
        }}
      >
        <CheckCircleTwoTone twoToneColor="#004d54" />
        {pillText}
      </div>
    ) : null}
    {title ? (
      <h2 style={{ margin: '12px 0 6px', fontWeight: 700, color: '#0f172a' }}>{title}</h2>
    ) : null}
    {subtitle ? (
      <p style={{ margin: 0, color: '#334155' }}>{subtitle}</p>
    ) : null}
  </div>
);

export default AuthHeader;


